module.exports = __webpack_public_path__ + "img/google.7a34680b.svg";